import React from "react";

const SmartSchoolSeoContent = () => {
  return (
    <section className="landing-seo-content" aria-label="Smart School System overview">
      <h2>Smart School System by eSyncing</h2>
      <p>
        Smart School System is a digital school platform by eSyncing designed
        to improve communication, announcements, and access to learning
        resources in modern schools.
      </p>

      <h3>What SmartClass Does</h3>
      <p>
        SmartClass connects teachers, students, parents, and school management
        in one platform. It supports real-time chat communication, school-wide
        announcements, and centralized learning resources.
      </p>

      <h3>Key Features</h3>
      <ul>
        <li>Chat communication between teachers and students</li>
        <li>Knowledge hub for notes, materials, and school content</li>
        <li>Announcements and notifications for school-wide updates</li>
        <li>Centralized digital communication instead of scattered chat groups</li>
      </ul>

      <h3>Who SmartClass Is For</h3>
      <p>
        SmartClass is designed for schools, school administrators, teachers,
        students, and parents who need a connected school communication and
        learning platform.
      </p>
    </section>
  );
};

export default SmartSchoolSeoContent;
